module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-parcel":"Update Parcel","parcel-updated":"Parcel updated","failed-update-parcel":"Failed to update parcel","failed-retrieve-parcel":"Failed to retrieve parcel","carrier":"Carrier"}}')
  delete Component.options._Ctor
}
